import {
  IGetAllIncidentsSingleResponse,
  IGetSingleIncidentResponse,
} from './api/operationsIncidentsApi.interface'

export type IncidentSeverity = 'L1' | 'L2' | 'L3' | 'L4'

export type IncidentStatus = 'open' | 'investigating' | 'acknowledged' | 'closed'

export type IncidentSeverityLevel = 1 | 2 | 3 | 4

export type IncidentStatusLevel = 1 | 2 | 3 | 4

export const INCIDENT_SEVERITY_COLORS: Record<IncidentSeverity, string> = {
  L1: '#B0B0B0',
  L2: '#F97316',
  L3: '#F4D03F',
  L4: '#E74C3C',
}

export const INCIDENT_SEVERITY_DESCRIPTIONS: Record<IncidentSeverity, string> = {
  L1: 'Minor',
  L2: 'Moderate',
  L3: 'Serious',
  L4: 'Fatal / catastrophic',
}

export interface IRaiseIncidentFormState {
  severity: IncidentSeverity
  title: string
  description: string
}

export const INCIDENT_STATUS_COLORS: Record<IncidentStatus, string> = {
  open: '#F4D03F',
  investigating: '#F97316',
  acknowledged: '#24D07B',
  closed: '#8A8A8A',
}

export const INCIDENT_STATUS_LABELS: Record<IncidentStatus, string> = {
  open: 'OPEN',
  investigating: 'INVESTIGATING',
  acknowledged: 'ACKNOWLEDGED',
  closed: 'CLOSED',
}

export interface IIncidentRow {
  id: number
  severity: IncidentSeverity
  timestamp: string
  title: string
  location: string
  status: IncidentStatus
}

export interface IIncidentsSliceInitialState {
  isLoading: boolean
  data: IGetAllIncidentsSingleResponse[]
  totalPages: number
  totalCount: number
  singleIncident: IGetSingleIncidentResponse | null
}
